import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static targets = [
  "userRole",
  "reviewerPermission",
  "reviewerBindingPermission",
  "allowReviewerToApproveCropStage",
  "reviewerStagePermission"]

  initialize() {
    // removing reviewer permissions and reviewer binidng action permissions from user form if user is not reviewer
    if (this.userRoleTarget.value != 'reviewer') {
      this.reviewerPermissionTarget.classList.add('d-none');
      this.reviewerBindingPermissionTarget.classList.add('d-none');
    } else {
      // Displaying binding actions stages options based on corresponding reviewer permission settings
      this.displayBindingActionsOptions();
    }

    this.handleReviewRequiredCheckboxIfApprovalRequired();
    this.handleUserStageAccessIfSetIsAllowed();
  }

  handleReviewRequiredCheckboxIfApprovalRequired() {
    let reviewRequiredCheckbox = '';

    if ($('#user_user_permission_attributes_approval_required_crop')[0].checked){
      reviewRequiredCheckbox = $('#user_user_permission_attributes_review_required_crop');
      this.markAndDisableReviewRequiredCheckbox(reviewRequiredCheckbox);
    }

    if ($('#user_user_permission_attributes_approval_required_sslice')[0].checked){
      reviewRequiredCheckbox = $('#user_user_permission_attributes_review_required_sslice');
      this.markAndDisableReviewRequiredCheckbox(reviewRequiredCheckbox);
    } 

    if ($('#user_user_permission_attributes_approval_required_highlight')[0].checked){
      reviewRequiredCheckbox = $('#user_user_permission_attributes_review_required_highlight');
      this.markAndDisableReviewRequiredCheckbox(reviewRequiredCheckbox);
    } 

    if ($('#user_user_permission_attributes_approval_required_type_o')[0].checked){
      reviewRequiredCheckbox = $('#user_user_permission_attributes_review_required_type_o');
      this.markAndDisableReviewRequiredCheckbox(reviewRequiredCheckbox);
    } 

    if ($('#user_user_permission_attributes_approval_required_type_l')[0].checked){
      reviewRequiredCheckbox = $('#user_user_permission_attributes_review_required_type_l');
      this.markAndDisableReviewRequiredCheckbox(reviewRequiredCheckbox);
    }
  }

  markAndDisableReviewRequiredCheckbox(reviewRequiredCheckbox) {
    reviewRequiredCheckbox.prop({ checked: true,});
    reviewRequiredCheckbox.addClass('disabled-checkbox')
  }

  // This method disables review required permissions based on approval required permissions
  handleReviewRequiredPermissions(e){
    const currentApprovalRequiredCheckbox   = e.currentTarget;
    const stage                             = currentApprovalRequiredCheckbox.dataset.approvalPermissionStage;
    const $correspondingStageAccessCheckbox = $(`input[type="checkbox"][data-runtime-permission-stage="${stage}"]`);
    const correspondingStageAccessCheckbox  = $correspondingStageAccessCheckbox[0];

    const currentApprovalRequiredCheckboxId = currentApprovalRequiredCheckbox.id;
    const correspondingReviewCheckboxId     = currentApprovalRequiredCheckboxId.replace('approval_required', 'review_required');
    const correspondingReviewCheckbox       = $(`#${correspondingReviewCheckboxId}`)[0];
    
    if (currentApprovalRequiredCheckbox.checked) {
      correspondingReviewCheckbox.checked      = true;
      correspondingStageAccessCheckbox.checked = false;

      correspondingReviewCheckbox.classList.add('disabled-checkbox');
      correspondingStageAccessCheckbox.classList.add('disabled-checkbox');
    } else {
      correspondingReviewCheckbox.classList.remove('disabled-checkbox');
      correspondingStageAccessCheckbox.classList.remove('disabled-checkbox');
    }
  }
  
  // Displays binding action stage options based on the corresponding reviewer permission settings
  displayBindingActionsOptions(){
    this.reviewerStagePermissionTargets.forEach(stageCheckbox => {
      // displaying binding action option if corresponding reviewer permission is checked
      if (stageCheckbox.checked){
        const bindingActionStageOptionTargetName= this.getBinindgActionOptionTarget(stageCheckbox.dataset.reviewerPermission); 
        this.displayBindingActionsOption(bindingActionStageOptionTargetName);
      }
    });
  }

  updateRole() {
    const selectedRole = this.userRoleTarget.value;

    if (selectedRole == 'reviewer') {
      this.reviewerPermissionTarget.classList.remove('d-none')
      this.reviewerBindingPermissionTarget.classList.remove('d-none')
    } else {
      this.reviewerPermissionTarget.classList.add('d-none')
      this.reviewerBindingPermissionTarget.classList.add('d-none')
    }
  }

  handleBindingActionOptions(e){
    // getting reviewer permission
    const toggleReviewerPermission = e.target.dataset.reviewerPermission;
    // toggleReviewerPermissionStageCheckboxes gets both access and approval-required sets checkboxes of reviewer permissions
    const toggleReviewerPermissionStageCheckboxes = document.querySelectorAll(`[data-reviewer-permission="${toggleReviewerPermission}"]`);
    
    const bindingActionStageOptionTargetName = this.getBinindgActionOptionTarget(toggleReviewerPermission);
    
    this.toggleBindingActionOption(bindingActionStageOptionTargetName, e.target.checked, toggleReviewerPermissionStageCheckboxes);
  }

  // Returns the target name for the binding action permission stage option  
  getBinindgActionOptionTarget(reviewerPermissionTargetName){
    // Mapping from reviewer permission to corresponding binding action stage target
    const bindingActionStageTargets = {
      'allow_reviewer_crop_stage': 'allow_reviewer_to_approve_crop_stage',
      'allow_reviewer_sslice_stage': 'allow_reviewer_to_approve_sslice_stage',
      'allow_reviewer_highlight_stage': 'allow_reviewer_to_approve_highlight_stage',
      'allow_reviewer_type_o_stage': 'allow_reviewer_to_approve_type_o_stage',
      'allow_reviewer_type_l_stage': 'allow_reviewer_to_approve_type_l_stage'
    };

    return bindingActionStageTargets[reviewerPermissionTargetName];
  }
  
  // Toggles display of binding actions options 
  toggleBindingActionOption(targetName, isChecked, reviewer_permission_checkboxes) {
    const allUnchecked = Array.from(reviewer_permission_checkboxes).every(checkbox => !checkbox.checked);

    if (isChecked) {
      this.displayBindingActionsOption(targetName);
    } else if (allUnchecked) {
      this.hideBindingActionOption(targetName);
    }
  }

  displayBindingActionsOption(targetName) {
    this.targets.find(targetName)?.classList.remove('collapse')
  }
  
  hideBindingActionOption(targetName){
    this.targets.find(targetName).classList.add('collapse')
  }

  handleUserStageAccessIfSetIsAllowed() {
    let stageAccessCheckbox = '';
    if ($('#user_user_permission_attributes_crop')[0].checked){
      stageAccessCheckbox = $('#user_user_permission_attributes_allow_user_crop_stage_runtime');
      this.markAndDisableStageAccessCheckbox(stageAccessCheckbox);
    }

    if ($('#user_user_permission_attributes_sslice')[0].checked){
      stageAccessCheckbox = $('#user_user_permission_attributes_allow_user_sslice_stage_runtime');
      this.markAndDisableStageAccessCheckbox(stageAccessCheckbox);
    } 

    if ($('#user_user_permission_attributes_highlight')[0].checked){
      stageAccessCheckbox = $('#user_user_permission_attributes_allow_user_highlight_stage_runtime');
      this.markAndDisableStageAccessCheckbox(stageAccessCheckbox);
    } 

    if ($('#user_user_permission_attributes_type_o')[0].checked){
      stageAccessCheckbox = $('#user_user_permission_attributes_allow_user_type_o_stage_runtime');
      this.markAndDisableStageAccessCheckbox(stageAccessCheckbox);
    } 

    if ($('#user_user_permission_attributes_type_l')[0].checked){
      stageAccessCheckbox = $('#user_user_permission_attributes_allow_user_type_l_stage_runtime');
      this.markAndDisableStageAccessCheckbox(stageAccessCheckbox);
    }    
  }

  markAndDisableStageAccessCheckbox(stageAccessCheckbox) {
    stageAccessCheckbox.prop({ checked: true,});
    stageAccessCheckbox.addClass('disabled-checkbox')
  }

  checkmarkCorrespondingStageAccessToggles(e) {
    const currentSetAccessCheckbox = e.currentTarget;

    const stage = currentSetAccessCheckbox.dataset.setPermissionStage;
    const correspondingStageAccessCheckbox = $(`input[type="checkbox"][data-runtime-permission-stage="${stage}"]`);
    
    if (currentSetAccessCheckbox.checked) {
      correspondingStageAccessCheckbox[0].checked = true;
      correspondingStageAccessCheckbox[0].classList.add('disabled-checkbox');
    } else {
      correspondingStageAccessCheckbox[0].classList.remove('disabled-checkbox');
    }
  }
}